import React from "react"
import { storeUserInfo } from '../utils/api'

export default class Feedback extends React.Component{
  state = {
    fb_rate: null,
    fb_mess: '',
    submit: false
  }


  handleTextAreaChange(e){
    this.setState({
      fb_mess: e.target.value
    })
  }

  handleRatingChange(i){
    this.setState({
      fb_rate: i
    })
  }

  handleSubmit(e){
    e.preventDefault();
    const { userId } = this.props;
    const { fb_mess, fb_rate } = this.state

    storeUserInfo
    ({
      userId,
      fb_rate,
      fb_mess,
    })
    .then((res) => {
      this.setState({
        submit: true
      })
    })
  }


  render(){
    let { frontpageObject } = this.props
    let { fb_mess, fb_rate, submit } = this.state

    return(
      <>
        <h2
          dangerouslySetInnerHTML={{__html: frontpageObject.title}}
        ></h2>
        <div className='text-block main-section__text-block'
          dangerouslySetInnerHTML={{__html: frontpageObject.description}}
        />
        <form onSubmit={(e) => this.handleSubmit(e)} className="form main-section__form">

          <div className="radio-ratings row">
            {[...Array(10)].map((x, i) =>
              (
                  <div key={i + 1} className="radio-rating">
                      <label className="radio-rating__label">
                        <input checked={fb_rate === i + 1 && 'checked'} onChange={() => this.handleRatingChange(i + 1)} type="radio" value={i + 1} name="rating" />
                        <span className="radio-rating__text">{i + 1}</span>
                      </label>
                  </div>
              )
            )}
          </div>

          <div className="form__line">
            <div className="form__label"
              dangerouslySetInnerHTML={{__html: frontpageObject.before_textarea}}
            />

            <textarea value={fb_mess} onChange={(e) => this.handleTextAreaChange(e)} className="form__textarea form__textarea_small"></textarea>
          </div>
          {submit && <h2 style={{color: 'darkseagreen'}} dangerouslySetInnerHTML={{__html: frontpageObject.feedback_success_text}} />}
          <div className="form-submit form-submit_marg row">
            <button type="submit" className="form-submit-btn form-submit-btn_small" >
              <span
                dangerouslySetInnerHTML={{__html: frontpageObject.button_text}}
              />
            </button>
            <a href="/" onClick={() => {e.preventDefault(); }} type="submit" className="form-submit-btn form-submit-btn_small">
              <span
                dangerouslySetInnerHTML={{__html: frontpageObject.home_button_text}}
              />
            </a>
          </div>
        </form>
      </>
    )
  }
}
